<template>
  <nav ref="navbar" class="navbar has-primary-background">
    <div class="container">
      <div class="navbar-brand">
        <router-link class="navbar-item" :to="'/'">
          <figure class="image relative">
            <img class="img" src="/fstatic/logo-text.svg" alt="" />
            <img class="absolute rotate" src="/fstatic/spinner.svg" alt="" />
          </figure>
        </router-link>

        <div
          class="navbar-burger burger"
          data-target="navMenubd-example"
          @click="menuIsActive = !menuIsActive"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div v-if="menuIsActive">
        <mobile-navbar
          :solutions="allSolutions"
          :capabilities="capabilities"
          @clicked="menuIsActive = false"
        ></mobile-navbar>
      </div>
      <div id="navMenubd-example" class="navbar-menu has-primary-background">
        <div class="navbar-end">
          <ul>
            <li :class="{ 'is-red': $route.path === '/' }">
              <router-link :to="'/'">
                {{ $t("navbar.home") }}
              </router-link>
            </li>
            <li :class="{ 'is-red': $route.path === '/about' }">
              <router-link :to="'/about'"> About Us </router-link>
            </li>
            <li :class="{ 'is-red': $route.name === 'capabilities' }">
              <dropdown
                route="capabilities"
                :capabilities="true"
                :itemsObj="capabilities"
              ></dropdown>
            </li>
            <li :class="{ 'is-red': $route.name === 'solutions' }">
              <dropdown
                route="solutions"
                :solutions="true"
                :itemsObj="solutions"
              ></dropdown>
            </li>
            <li :class="{ 'is-red': $route.path === '/careers' }">
              <router-link :to="'/careers'"> Careers </router-link>
            </li>
            <li :class="{ 'is-red': $route.path === '/contact' }">
              <router-link :to="'/contact'"> Contact Us </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import Dropdown from "@/components/utils/Dropdown";
import mobileNavbar from "@/components/utils/mobileNavbar";
// http://atd-cms.nbhood.com/api/collections/get/capabilities?token=8864674b01000e6d7d030ef8c41e72&populate=1&filter[capability_category]=catB
//collections/get/Case?token=mytoken&filter[_id]=myentryid
import { bus } from "@/main";
export default {
  components: {
    Dropdown,
    mobileNavbar,
  },
  created() {
    // loop over capabilities categories
    this.axios
      .get(
        `https://${this.baseURL()}/api/singletons/get/capabilities_categories?token=8864674b01000e6d7d030ef8c41e72`
      )
      .then((data) => {
        this.capabilities = data.data.categories;
        this.capabilitiesInitialRoute = this.capabilities[0].value;
        bus.$emit("capabilitiesInitialRoute", this.capabilitiesInitialRoute);
      });
    // loop over solutions categories
    this.axios
      .get(
        `https://${this.baseURL()}/api/singletons/get/solutions_categories?token=8864674b01000e6d7d030ef8c41e72`
      )
      .then((data) => {
        const array = data.data.Categories;
        this.allSolutions = data.data.Categories;
        array.filter((e) => e.field.label === "Category");
        // know the indexes of `category`
        let indeces = [];
        array.map((e) =>
          e.field.label === "Category" ? indeces.push(array.indexOf(e)) : null
        );
        // cut array from one index till next index
        for (let i = 0; i < indeces.length; i++) {
          this.solutions.push(array.slice(indeces[i], indeces[i + 1]));
        }
        this.solutionsInitialRoute = this.solutions[0][1].value;
        bus.$emit("solutionsInitialRoute", this.solutionsInitialRoute);
      });
  },
  data() {
    return {
      isActive: false,
      menuIsActive: false,
      solutions: [],
      capabilities: [],
      allSolutions: [],
    };
  },
  watch: {
    $route(to, from) {
      this.menuIsActive = false;
      if (this.capabilitiesInitialRoute)
        bus.$emit("capabilitiesInitialRoute", this.capabilitiesInitialRoute);
      if (this.solutionsInitialRoute)
        bus.$emit("solutionsInitialRoute", this.solutionsInitialRoute);
    },
    "$mq.resize": function (argument) {
      if (argument > 1022) {
        this.menuIsActive = false;
      }
    },
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "../assets/scss/vars";
.rotate {
  animation: rotate 2.5s infinite;
}
@keyframes rotate {
  0% {
    transform: rotate(-180deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
nav {
  @media (min-width: 770px) {
    padding: 0.6rem;
    padding-bottom: 0rem;
  }
}
.red {
  color: red;
}
figure {
  margin-left: 25px;
}
.img {
  width: 160px;
  height: auto;
  margin-right: 5px;
  margin-top: 20px;
}
img.absolute {
  top: 0px;
  left: -30px;
  width: 35px;
}
.current {
  color: red;
}
.is-active {
  ul {
    flex-direction: column;
    align-items: right;
    li {
      padding: 0.6em 1.8em 0em 1.8em;
      // padding-bottom: 0rem;
      border-bottom: 1px solid gray;
      width: 100%;
    }
    li:last-child {
      border-bottom: none;
    }
  }
}
.is-red {
  * {
    color: inherit;
  }
}
.navbar-brand {
  align-items: center;
  @media (max-width: 770px) {
    padding: 0rem 1rem;
    align-items: flex-end;
  }
  .navbar-burger {
    color: white;
  }
}
li {
  font-weight: 400;
  font-size: 1.1rem;
  color: white;
  padding: 0.8em;
  height: 50px;
  padding-bottom: 0px !important;
  cursor: pointer;
  a {
    color: white;
    &:hover {
      color: inherit;
    }
  }
}
ul {
  display: flex;
  align-items: flex-end;
}
.navbar-menu {
  padding-bottom: 0px;
}
.navbar-item {
  &:hover {
    color: inherit;
    background: inherit;
  }
  img {
    max-height: 200px;
  }
}
</style>



// WEBPACK FOOTER //
// header.vue?bdc95c76